var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 21C4.79086 21 3 19.2091 3 17L3 7C3 4.79086 4.79086 3 7 3H11C13.2091 3 15 4.79086 15 7C15 7.55229 14.5523 8 14 8C13.4477 8 13 7.55229 13 7C13 5.89543 12.1046 5 11 5H7C5.89543 5 5 5.89543 5 7L5 17C5 18.1046 5.89543 19 7 19H11C12.1046 19 13 18.1046 13 17C13 16.4477 13.4477 16 14 16C14.5523 16 15 16.4477 15 17C15 19.2091 13.2091 21 11 21H7Z",
    fill: "black",
    fillOpacity: 0.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H18.6018L16.5858 14.9911L17.9912 16.4141L21.7027 12.7485C21.8914 12.5621 21.9983 12.3084 22 12.0431C22.0016 11.7779 21.8978 11.5229 21.7114 11.3342L18.0087 7.58569L16.5858 8.99119L18.5701 11H10Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArrowRight);
export default __webpack_public_path__ + "static/media/box-arrow-right.c2e12f97f49752e36341cbaef05d937b.svg";
export { ForwardRef as ReactComponent };